<template>
  <div class="my-2">
    <div class="row" @click="setAccordion(data.id)">
      <div class="col-12 text-dark p-2 d-flex question">
        <span class="mr-auto">Pregunta #{{ data.item }}</span>
        <i class="fas fa-caret-down pt-2"></i>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <div v-if="data.showDetail">
        <div class="row my-3">
          <div class="col-12">
            {{ data.contenido }}
          </div>
        </div>
        <div class="row text-brown-light">
          <div
            class="col-12"
            v-for="res in data.mdTestPreguntaRespuestases"
            :key="res.id"
          >
            {{ res.contenido }}
          </div>
        </div>
        <div class="row text-logo text-end mt-3">
          <div class="col-12">
            {{ data.mdTestPreguntaRespuestaCorrecta.contenido }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "QuestionAccordion",
  props: ["data"],
  methods: {
    setAccordion(id) {
      if (this.data.showDetail == true) {
        this.$emit("setAccordion");
      } else {
        this.$emit("setAccordion", id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.question {
  box-shadow: 0px 5px 5px 1px rgba(64, 64, 64, 0.1);
  border-radius: 5px;
}

.fa-caret-down {
  float: right;
}
</style>
